function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Space, Button, Skeleton, message, Drawer } from 'antd';
import { UmbrellaFill, Building, PieChartFill, XSquareFill } from 'react-bootstrap-icons';
import NewCompany from "../components/forms/NewCompany";
import NewInsurance from "../components/forms/NewInsurance";
import Common from "../components/includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Companies = function Companies() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      newCompanyVisible = _useState2[0],
      setNewCompanyVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      newInsuranceVisible = _useState4[0],
      setNewInsuranceVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      reportsDrawerVisible = _useState6[0],
      setReportsDrawerVisible = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      cList = _useState8[0],
      setcList = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      dataChanged = _useState12[0],
      setDataChanged = _useState12[1];

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setcList(response.data.companyList);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 9,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: function onClick() {
                setNewCompanyVisible(true);
              },
              icon: /*#__PURE__*/_jsx(Building, {}),
              children: " Ajouter Entreprise"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            className: "cool-radius white-bg",
            children: [/*#__PURE__*/_jsxs(Table, {
              responsive: true,
              bordered: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Ref"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Tel"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Adresse"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Couverture"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Assurance"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: cList.map(function (ic) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: ic.id
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.label
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.telephone
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.address
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [ic.rate, " %"]
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.company && /*#__PURE__*/_jsx("b", {
                        children: ic.company.label
                      })
                    })]
                  }, ic.id);
                })
              })]
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: newCompanyVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter une entreprise",
      onClose: function onClose() {
        setNewCompanyVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewCompany, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: newInsuranceVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un assureur",
      onClose: function onClose() {
        setNewInsuranceVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewInsurance, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    })]
  });
};

export default Companies;